import { render, staticRenderFns } from "./ReportCustomersBalancePage.vue?vue&type=template&id=2e0e3f16&scoped=true"
import script from "./ReportCustomersBalancePage.vue?vue&type=script&lang=js"
export * from "./ReportCustomersBalancePage.vue?vue&type=script&lang=js"
import style0 from "./ReportCustomersBalancePage.vue?vue&type=style&index=0&id=2e0e3f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0e3f16",
  null
  
)

export default component.exports